export function removeBrowserSupport() {
    const isNotSupported =
        !!window.MSInputMethodContext && !!document.documentMode;

    const shouldBeHidden = Boolean(getCookieValue("hideUnSupportMessage"));
    const root = document.getElementById("wrapper");

    function getCookieValue(cookieKey) {
        const [result] = document.cookie
            .split("; ")
            .map((cookie) => cookie.split("="))
            .filter(([key, _value]) => key === cookieKey)
            .map(([_key, value]) => value);
        return result;
    }

    //@ts-ignore
    window.notSupported = function handleClose() {
        const now = new Date();
        const time = now.getTime();
        // + 100 days
        const expireTime = time + 1000 * 60 * 60 * 24 * 100;
        now.setTime(expireTime);
        const cookieString = "hideUnSupportMessage=true; max-age=100000";
        document.cookie = cookieString;

        const elem = document.getElementById("not-supported");
        if (elem) {
            elem.style.display = "none";
        }
    };

    if (isNotSupported && !shouldBeHidden) {
        root?.insertAdjacentHTML(
            "afterend",
            `
        <h3> “We no longer support Internet Explorer 11. Please upgrade to the latest Microsoft Edge, Google Chrome or Firefox.”</h3>
      <footer
        id="not-supported"
        style="
          position: fixed;
          bottom: 0px;
          box-shadow: rgba(0,0,0,0.3) 0px 0px 10px;
          background-color: #f3f3f447;
          width: 100%;
          font-family: National-Light, 'Calibri Light', Calibri, 'Helvetica Neue', Helvetica, Arial, sans-serif;
          text-align: center;
          color: #fff;
          font-size: 16px;
          z-index: 999;
          cursor: pointer;
        "
        onclick="window.notSupported();"
      >
        <h3> “We no longer support Internet Explorer 11. Please upgrade to the latest Microsoft Edge, Google Chrome or Firefox.”</h3>
      </footer>
    `
        );
    }
}
